import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectAccountTypesListItems } from '../../../../redux/account-types/selector';
import { accounts } from '../../../../redux/accounts/action';
import PageLoader from '../../../../components/PageLoader';
import { ventures } from '../../../../redux/ventures/action';
import { selectVenturesQueryItems } from '../../../../redux/ventures/selector';
import  { VentureComponent } from '../components/venture.component';


const ManagementAgent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const VentureQuery = useSelector(selectVenturesQueryItems)
    const [
        selectedVenture,
        setSelectedVenture
    ] = useState<any>([])

    const [
        selectedAccounts,
        setSelectedAccounts
    ] = useState<any>({
        LoginInfo: {},
        UserInfo: {},
        AccountInfo: {
            IsPersonAccount: true,
            IsCustomerPortalEnabled: false,
            IsVendorPortalEnabled: false,
            IsPartnerEnabled: false,
            IsAccountVerified: true,
            IsGuestAccessEnabled: true,
            IsLimitedToOrganizationUnit: false,
            EnableOnNetworkLogisticsSupport: true,
            MappedAccountTypes: {}
        },
        AccountAddress: {},
        PrimaryAddress: {}

    })
    const fetchAgentQueryById = () => {
        dispatch(ventures.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/query`, entity: 'venture', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedAccounts({ ...selectedAccounts, [fields[0]]: value });
        setSelectedVenture({ ...selectedVenture, [fields[0]]: value });
    }


    useEffect(
        () => {
            dispatch(() => {
                    if (parmas?.id > 0) {
                        fetchAgentQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedVenture(VentureQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            await dispatch(ventures.resetAction({ actionType: 'update' }))
            await dispatch(ventures.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures`, entity: 'venture', jsonData: {

                    Records: [
                        selectedVenture

                    ]
                }
            })).then(() => {
                back()
            })

        } else if (selectedAccounts?.LoginInfo?.Password === selectedAccounts?.LoginInfo?.ConfirmPassword) {
            selectedAccounts.UserInfo.Salutation = 0
            let accountTypes = _.find(accountTypeItems.result.items, ['Name', 'Venture']);
            selectedAccounts.AccountInfo.Name = `${selectedAccounts?.UserInfo?.FirstName} ${selectedAccounts?.UserInfo?.LastName}`
            selectedAccounts.AccountInfo.TypeId = 410 //accountTypes.Id
            selectedAccounts.AccountInfo.IsPersonAccount = false
            selectedAccounts.AccountInfo.MappedAccountTypes.MappedAccountTypeIds = [accountTypes.Id]
            selectedAccounts.AccountAddress.PrimaryAddress = selectedAccounts?.PrimaryAddress
            selectedAccounts.AccountAddress.PrimaryAddress.FaxNumber = selectedAccounts?.LoginInfo.PhoneNumber
            selectedAccounts.AccountAddress.PrimaryAddress.GeocodeAccuracy = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Latitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Longitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.OpeningHoursTypeId = 30,
                selectedAccounts.AccountAddress.IsUsePrimaryAddressAsBillingAddress = true
            selectedAccounts.AccountAddress.IsUsePrimaryAddressAsShippingAddress = true
            selectedAccounts.AccountAddress.BillingAddress = {}
            selectedAccounts.AccountAddress.ShippingAddress = {}
            const data = _.omit(selectedAccounts, 'PrimaryAddress');
            await dispatch(accounts.resetAction({ actionType: 'create' }))
            await dispatch(accounts.create({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts`, entity: 'accounts', jsonData: {

                    Records: [
                        {
                            Context: {},
                            Message: data

                        }
                    ]

                }
            })).then(() => {
                back()
            })
        } else {
            toast.error("Password and Confirm Password must be same.")
        }

    }

    const back = () => {
        navigate('/management/e-applications/onesp/ventures')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <VentureComponent
                    selectedAccounts={selectedAccounts}
                    handleInnerFormChange={handleInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    selectedVenture={selectedVenture}
                />
            }

        </>
    )

}

export default ManagementAgent;